// extracted by css-extract-rspack-plugin
export default {"group":"cf1SSNFFgQEElmGS"};